import { inject, observer } from 'mobx-react';
import React, { Component } from 'react';
import { Link, Route } from 'react-router-dom';
import { Layout } from '.';

import { PostDetail } from '.';
import { Date, Progress } from '../components';
import Links from '../components/Links';
import StoriesBar from '../components/StoriesBar';

import axios from '../lib/axios';

@inject('PostStore', 'AuthenticationStore') @observer
export default class PostList extends Component {
  componentWillMount() {
    const { PostStore } = this.props;
    PostStore.fetch();
  }

  handleClickHighlight(id) {
    return async () => {
      const { data: { slug, entity } } = await axios.get(`/v2/highlights/${id}`);

      const urls = {
        POST: `/novidades/ver/${slug}`,
        COURSE: `/cursos/ver/${slug}`,
        PRODUCT: `/p/${slug}`,
        SALE: `/ofertas-e-combos/${slug}`,
        DOCUMENT: `/material-de-apoio/ver/${slug}`
      }
      this.props.history.push(urls[entity]);
	  }
  }

  render() {
    const { PostStore, AuthenticationStore } = this.props;
    const { user: { user_group: { features } } } = AuthenticationStore;
    return (
      <Layout footerStyle={{ backgroundColor: '#FFF' }}>
        <Route path={`${this.props.match.url}/ver/:slug`} component={PostDetail} onChange={(prevState, nextState) => {
          if (nextState.location.action !== "POP") {
            window.scrollTo(0, 0);
          }
        }} />
        <section className="novidades listagem">
          {PostStore.isLoading && <Progress />}
          { features.includes('LINK') && <Links /> }
          { features.includes('STORY') && <StoriesBar /> }

          {!PostStore.isLoading &&
            <ul className="novidades-destaque">
              { 
                PostStore.highlights.map((highlight) => {
                  return (
                    <li key={`destaque-${highlight.id}`}>
                      <a onClick={this.handleClickHighlight(highlight.id)} title={highlight.title}>
                        <div className="content">
                          
                          <h3>{highlight.title}</h3>
                          <button>Veja mais</button>
                        </div>
                        <img className="cover" src={highlight.image_desktop} alt={highlight.title} />
                      </a>
                    </li>
                  )
                }
              )}
            </ul>
          }

          {!PostStore.isLoading &&
            <section className="main">
              <div className="noticias-filtro">
                <ul className="categorias-noticias">
                  <li>
                    <button className={!PostStore.categoryId ? 'active' : ''} onClick={() => PostStore.clearFilterCategory()}>Todas</button>
                  </li>
                  {PostStore.categories.map((category) => (
                    <li key={`category-${category.id}`}>
                      <button className={PostStore.categoryId === category.id ? 'active' : ''} onClick={() => PostStore.filterCategory(category.id)}>{category.name}</button>
                    </li>
                  ))}
                </ul>
              </div>

              <ul className="novidades-listagem">
                {PostStore.posts.map((post) => (
                  <li key={`noticia-${post.id}`}>
                    <Link to={`/novidades/ver/${post.slug}`} title={post.title}>
                      <div className="image">
                        <img src={post.image_banner} alt={post.title} />
                      </div>

                      <div className="content">
                        <Date date={post.date} />
                        <span className="title">{post.title}</span>
                        <button>Veja mais</button>
                      </div>
                    </Link>
                  </li>
                ))}
              </ul>
            </section>
          }
        </section>
      </Layout>
    );
  }
}



// WEBPACK FOOTER //
// ./src/screens/PostList.js